export type AiEntityDescriptor = {
    name: string // Canonical model name, e.g. "SupportClaim", "ProviderMessage".
    description?: string //Optional human‑readable description of the entity type.
    schema?: unknown //Optional OpenAPI (or OpenAPI‑like) schema fragment for this entity, including field descriptions. 
  }

  
/**
 * Minimal, hand‑curated schema fragments for entities that we want to expose to AI.
 */
export const aiEntitySchemas: Record<string, Partial<AiEntityDescriptor>> = {
    Claim: {
        description: 'High-level claim record with responsibility and validation context. (Canonical alias for provider/support claim shapes.)',
        schema: {
            properties: {
                accountNumber: {
                    description: 'Visit account number from the EMR.',
                },
                claimResponsibilityType: {
                    description: 'Who is currently responsible for the claim (payer vs patient, etc.).',
                },
                claimResponsibilityCategoryType: {
                    description: 'More granular responsibility category for the claim.',
                },
                maximumGuarantorResponsibility: {
                    description: 'Maximum amount the guarantor is responsible for.',
                },
                claimValidationErrors: {
                    description: 'Validation errors detected on this claim.',
                },
                claimValidated: {
                    description: 'Whether validation has been run on this claim.',
                },
            },
        },
    },
    SupportClaim: {
        description: 'High‑level claim record with responsibility and validation context.',
        schema: {
            properties: {
                accountNumber: {
                    description: 'Visit account number from the EMR.',
                },
                claimResponsibilityType: {
                    description: 'Who is currently responsible for the claim (payer vs patient, etc.).',
                },
                claimResponsibilityCategoryType: {
                    description: 'More granular responsibility category for the claim.',
                },
                maximumGuarantorResponsibility: {
                    description: 'Maximum amount the guarantor is responsible for.',
                },
                claimValidationErrors: {
                    description: 'Validation errors detected on this claim.',
                },
                claimValidated: {
                    description: 'Whether validation has been run on this claim.',
                },
            },
        },
    },
    Message: {
        description: 'Generic support message containing subject, body, sender, comments and linked entities such as claims and codings.',
        schema: {
            properties: {},
        },
    },
    ProviderPatientStatement: {
        description: 'Patient statement data for provider-facing view: patient, billing provider, balance due, payment sources, and associated claims.',
        schema: {
            properties: {
                balanceDue: {
                    description: 'Total balance due for the patient statement.',
                },
                patient: {
                    description: 'Patient identity and demographic data.',
                },
                billingProvider: {
                    description: 'Provider organization and contact information that generated the statement.',
                },
                paymentSources: {
                    description: 'Collection payment sources used to compute statement amounts.',
                },
                claims: {
                    description: 'Linked claim statements that contribute to this patient statement.',
                },
            },
        },
    },
};

